export const STORE_PREFIX = "talkee_";

export const STORE_KEYS = {
  TOKEN: "token",
};
